/* components/kitchen/menu/SectionHeader.jsx — заголовок раздела меню.
   Зеркалит конструктор разделов из чат-канваса (DraftEntityCard): всегда
   открытое поле названия (commit на Blur/Enter, Esc — отмена), счётчик блюд,
   кнопки ↑/↓ (desktop + mobile), удаление раздела (ConfirmDialog).
   ХЕНДОФФ → frontend/src/components/kitchen/menu/SectionHeader.jsx. */

import React from 'react';
import { useConfirm } from '../../../app/providers/ConfirmProvider.jsx';
import { IconButton } from '../../ui/Buttons.jsx';

  const { useState, useEffect } = React;

  function SectionHeader({ section, count, onRename, onMove, onDelete, canUp, canDown }) {
    const confirm = useConfirm();
    const [val, setVal] = useState(section.title);

    useEffect(() => { setVal(section.title); }, [section.title]);

    // Поле всегда открыто (как в канвасе); правка фиксируется на потере фокуса
    // или Enter, чтобы не дёргать dirty/preview на каждый символ.
    const commit = () => {
      const t = val.trim();
      if (t && t !== section.title) onRename && onRename(t);
      else if (!t) setVal(section.title);
    };
    const onKey = (e) => {
      if (e.key === 'Enter') { e.preventDefault(); e.currentTarget.blur(); }
      else if (e.key === 'Escape') { setVal(section.title); e.currentTarget.blur(); }
    };

    const del = async () => {
      const ok = await confirm({ title: 'Удалить раздел?', body: 'Раздел «' + section.title + '» будет удалён. Блюда из него переместятся в первый доступный раздел.', confirmLabel: 'Удалить раздел', tone: 'danger' });
      if (ok) onDelete && onDelete();
    };

    return (
      <div className="sec-header">
        <input className="sec-header__input" value={val} placeholder="Название раздела"
          onChange={(e) => setVal(e.target.value)} onBlur={commit} onKeyDown={onKey} aria-label="Название раздела" />
        <span className="sec-header__count num">{count}</span>
        <div className="sec-header__act">
          <IconButton icon="chevron-up" size="sm" variant="ghost" tooltip="Выше" disabled={!canUp} onClick={() => onMove && onMove(-1)} />
          <IconButton icon="chevron-down" size="sm" variant="ghost" tooltip="Ниже" disabled={!canDown} onClick={() => onMove && onMove(1)} />
          <IconButton icon="trash" size="sm" variant="ghost" tooltip="Удалить раздел" onClick={del} />
        </div>
      </div>
    );
  }

export { SectionHeader };
